import { getSupabaseClient } from "../../providers/supabase/supabase";
import { enroll, type Sequence } from "../sequences/enroll";

/**
 * Pasa empresas del directorio al CRM (promote_directory: respeta No contactar y
 * reusa la oportunidad si ya existe) y, opcionalmente, las inscribe en una cadencia.
 */
export const promoteMany = async (
  ids: (number | string)[],
  offer: { id: number; slug: string },
  sequence: Sequence | null,
  salesId: number,
) => {
  const sb = getSupabaseClient();
  const dealIds: number[] = [];
  const companyIds: number[] = [];
  const errors: string[] = [];
  let enrolled = 0;
  for (const id of ids) {
    const { data, error } = await sb.rpc("promote_directory", {
      p_directory_id: Number(id),
      p_offer_slug: offer.slug,
    });
    if (error) {
      errors.push(error.message);
      continue;
    }
    dealIds.push(data as number);
    const { data: deal } = await sb
      .from("deals")
      .select("contact_ids, company_id")
      .eq("id", data)
      .single();
    if (deal) companyIds.push(deal.company_id);
    if (!sequence || !deal?.contact_ids?.[0]) continue;
    try {
      await enroll({
        sequenceId: sequence.id,
        offerId: offer.id,
        contactId: deal.contact_ids[0],
        companyId: deal.company_id,
        dealId: data as number,
        salesId,
      });
      enrolled++;
    } catch {
      // ya inscrito: se deja como está
    }
  }
  return { dealIds, companyIds, errors, enrolled };
};

/** Mensaje para el aviso después de pasar al CRM. */
export const promoteMessage = (
  r: Awaited<ReturnType<typeof promoteMany>>,
  offerName: string,
  sequenceName?: string,
): [string, "success" | "warning" | "error"] => {
  if (r.errors.length) {
    const dnc = r.errors.filter((e) => e.includes("no contactar")).length;
    return [
      `${r.dealIds.length} pasadas al CRM · ${r.errors.length} con error` +
        (dnc ? ` (${dnc} en lista de no contactar)` : `: ${r.errors[0]}`),
      r.dealIds.length ? "warning" : "error",
    ];
  }
  return [
    (r.dealIds.length === 1
      ? `Oportunidad de ${offerName} lista`
      : `${r.dealIds.length} empresas pasadas al CRM en ${offerName}`) +
      (sequenceName ? ` · ${r.enrolled} inscritas en ${sequenceName}` : ""),
    "success",
  ];
};
